module.exports = __webpack_public_path__ + "1b29841536ce71365e3043bcfb8481b6.svg";